module.exports = __webpack_public_path__ + "img/logo.eab0d6e7.png";